import { render, staticRenderFns } from "./MedicalManagement.vue?vue&type=template&id=00981316&scoped=true"
import script from "./MedicalManagement.vue?vue&type=script&lang=js"
export * from "./MedicalManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00981316",
  null
  
)

export default component.exports